import { useEffect, useState } from "react";
import { api, ANLAGEN_TYPEN, formatApiErrorDetail } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { AlertTriangle, Check, X } from "lucide-react";
import { toast } from "sonner";

export default function Erinnerungen() {
  const [items, setItems] = useState([]);

  const load = async () => {
    const { data } = await api.get("/reminders");
    setItems(data);
  };
  useEffect(() => { load(); }, []);

  const dismiss = async (id) => {
    try {
      await api.post(`/reminders/${id}/dismiss`);
      toast.success("Erinnerung geschlossen");
      load();
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
  };

  const markFertig = async (id) => {
    try {
      await api.patch(`/anmeldungen/${id}`, { status: "fertiggemeldet" });
      toast.success("Als fertiggemeldet markiert");
      load();
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
  };

  return (
    <div className="p-8 space-y-6 animate-fade-up" data-testid="erinnerungen-page">
      <div>
        <div className="overline">14-Tage-Regel</div>
        <h1 className="font-heading text-4xl font-bold tracking-tight mt-2">Erinnerungen</h1>
        <p className="text-muted-foreground mt-1">
          Anmeldungen älter als 14 Tage ohne Fertigmeldung. Bitte prüfen &amp; abschließen.
        </p>
      </div>

      {items.length === 0 ? (
        <Card className="border-border">
          <CardContent className="p-12 text-center">
            <Check className="h-10 w-10 mx-auto text-primary" />
            <div className="font-heading text-xl font-semibold mt-4">Alles im grünen Bereich</div>
            <div className="text-sm text-muted-foreground mt-1" data-testid="no-reminders">
              Keine überfälligen Anmeldungen.
            </div>
          </CardContent>
        </Card>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-testid="reminders-list">
          {items.map((r) => (
            <Card key={r.id} className="border-amber-300/70 dark:border-amber-800/60" data-testid={`reminder-${r.id}`}>
              <CardContent className="p-5">
                <div className="flex items-start justify-between gap-3">
                  <div className="flex items-start gap-3">
                    <div className="h-9 w-9 rounded-md bg-amber-100 dark:bg-amber-900/40 flex items-center justify-center shrink-0">
                      <AlertTriangle className="h-5 w-5 text-amber-700 dark:text-amber-400" />
                    </div>
                    <div>
                      <div className="font-medium">{r.kunde_name}</div>
                      <div className="text-xs text-muted-foreground mt-0.5">
                        {ANLAGEN_TYPEN[r.anlagen_typ]} · {r.leistung_kw} kW
                      </div>
                      <div className="text-xs mt-2">
                        Angemeldet am <span className="font-medium">{r.anmeldedatum}</span> — vor
                        <span className="font-bold text-amber-700 dark:text-amber-400"> {r.tage_seit_anmeldung} Tagen</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex gap-2 mt-4">
                  <Button size="sm" onClick={() => markFertig(r.id)} data-testid={`reminder-fertig-${r.id}`}>
                    <Check className="h-4 w-4 mr-1.5" /> Fertiggemeldet
                  </Button>
                  <Button size="sm" variant="outline" onClick={() => dismiss(r.id)} data-testid={`reminder-dismiss-${r.id}`}>
                    <X className="h-4 w-4 mr-1.5" /> Ausblenden
                  </Button>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
